import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Institute
 */
@Entity()
export class Institute extends Partner {
  static override _class = 'Institute';

  override get type() {
    return KooperationsPartner.INSTITUTE;
  }
}
